module.exports = __webpack_public_path__ + "static/media/snow.fbc07ae8.svg";